// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a13ddc65","453":"8701dc61","617":"4e75ee11"}[chunkId] + ".chunk.js";
};